export default __webpack_public_path__ + "static/bulletpnt-6e1f7bbb7e636ee3102ffa1bcf498cf5.png";